import { plantarApi } from '@/config/appAPIs'

const api = {
  resource: '',
  request: plantarApi,
  setResource(resource: string) {
    this.resource = resource
    return this
  },
  setApiVersion(version?: number) {
    const { plantar } = (<any>window).configuration || { plantar: {} }
    this.request.defaults.baseURL = [plantar.host, `api/v${version || 1}`].join('/')
    return this
  },
  getPath(resourceId?: string) {
    return resourceId ? [this.resource, resourceId].filter(r => r).join('/') : this.resource
  },
  get<T>(resourceId?: string, params?: any, options?: any) {
    return plantarApi.get<T>(this.getPath(resourceId), {
      ...options,
      params,
      paramsSerializer: {
        indexes: null
      }
    })
  },
  post<T>(resourceId?: string, data?: any, options?: any, isMultipart?: boolean) {
    const headers = {}
    if (isMultipart) headers['Content-Type'] = 'multipart/form-data'

    return plantarApi.post<T>(this.getPath(resourceId), data, {
      headers,
      ...options
    })
  },
  put<T = any>(resourceId?: string, data?: any, options?: any, isMultipart?: boolean) {
    const headers = {}
    if (isMultipart) headers['Content-Type'] = 'multipart/form-data'

    return plantarApi.put<T>(this.getPath(resourceId), data, {
      headers,
      ...options
    })
  },
  delete(resourceId?: string, data?: any) {
    return plantarApi.delete(this.getPath(resourceId), { data })
  }
}

export default api
